export default __webpack_public_path__ + "static/media/13.35fb96c9.svg";